module.exports = __webpack_public_path__ + "et.svg?28e0ba20bb6924d7296d9569ce7dab0e";